<template>
<kt-panel>
    <div class="accordion accordion-toggle-arrow" id="userFilter">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse" 
                    data-target="#filterForm"
                    aria-controls="filterForm">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                <div class="card-body">
                    <form id="settlement_export_form" @submit.prevent="action($event, query)">
                        <kt-form-section>
                        <kt-form-row>
                            <kt-col xs="12" sm="12" md="4" lg="4">
                                <kt-form-group>
                                    <kt-form-label for="settlement_id">
                                        {{ $t('label.settlement_id') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            ref="settlement_id"
                                            dir="ltr"
                                            name="settlement_id"
                                            id="settlement_id"
                                            v-model="query.settlement_id"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" sm="12" md="4" lg="4">
                                <kt-form-group>
                                    <kt-form-label for="full_name">
                                        {{ $t('label.user_full_name') }}
                                    </kt-form-label>
                                        <kt-form-control ref="full_name" dir="ltr" name="full_name" id="full_name" v-model="query.full_name" />
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" sm="12" md="4" lg="4">
                                <kt-form-group>
                                    <kt-form-label for="filter_status">
                                        {{ $t('label.status') }}
                                    </kt-form-label>
                                    <kt-form-select size="4" id="status" class="form-control" name="status" v-model="query.status">
                                        <option
                                                v-bind:key="index"
                                                v-for="(status, index) in statuses"
                                                v-bind:value="status.value"
                                                :selected="query.status === status.value"
                                        >
                                            {{ status.name }}
                                        </option>
                                    </kt-form-select>
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                        <kt-form-row>
                            <kt-col xs="12" sm="4" md="4">
                                <kt-form-group>
                                    <kt-form-label for="from_date">
                                        {{ $t('label.from_date') }}
                                    </kt-form-label>
                                    <button id="reset_from_date"
                                            @click="clearFromDate"
                                            class=" btn btn-label-danger trash-btn"
                                    >
                                        <i class="la la-trash-o"></i>
                                    </button>
                                    <datePicker
                                            color="#00c1a4"
                                            format="YYYY-MM-DD HH:mm:ss"
                                            display-format="dddd jDD jMMMM jYYYY"
                                            input-class="form-control"
                                            id="from_date"
                                            name= "from_date"
                                            v-model="query.from_date"
                                            type="date" />
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" sm="4" md="4">
                                <kt-form-group>
                                    <kt-form-label for="to_date">
                                        {{ $t('label.to_date') }}
                                    </kt-form-label>
                                    <button id="reset_to_date"
                                            @click="clearToDate"
                                            class=" btn btn-label-danger trash-btn"
                                    >
                                        <i class="la la-trash-o"></i>
                                    </button>
                                    <datePicker
                                            color="#00c1a4"
                                            format="YYYY-MM-DD HH:mm:ss"
                                            display-format="dddd jDD jMMMM jYYYY"
                                            input-class="form-control"
                                            id="to_date"
                                            name= "to_date"
                                            v-model="query.to_date"
                                            type="date"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" sm="4" md="4">
                                <kt-form-group>
                                    <kt-form-label for="reference_number">
                                        {{ $t('label.reference_number') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            ref="reference_number"
                                            dir="ltr"
                                            name="reference_number"
                                            id="reference_number"
                                            v-model="query.reference_number"
                                    />
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                    </kt-form-section>
                        <kt-form-section>
                        <kt-row>
                            <kt-col xs="12" sm="6" md="6">
                                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">                            </kt-col>
                            <kt-col xs="12" sm="6" md="6">
                                <button
                                        class="btn btn-success btn-wide float-right"
                                        size="md"
                                        type="button"
                                        id="settlement_export_btn"
                                        @click="exportExcel($event, query)"
                                >
                                    {{ $t('reports.btn.export_settlements_to_excel') }}
                                </button>
                            </kt-col>
                        </kt-row>
                    </kt-form-section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</kt-panel>
</template>

<script>
import { statusStr, settlementStatus } from '@/constants/settlementStatus'

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        },
        exportExcel: {
            default: function(e, query) {},
            required: true,
        }
    },
    data() {
        return {
            statuses: [
                {
                    name: null,
                    value: null
                },
                {
                    name: statusStr.CREATED,
                    value: settlementStatus.CREATED
                },
                {
                    name: statusStr.SENT_TO_SHAPARAK,
                    value: settlementStatus.SENT_TO_SHAPARAK
                },
                {
                    name: statusStr.ACCEPTED,
                    value: settlementStatus.ACCEPTED
                },
                {
                    name: statusStr.REJECTED,
                    value: settlementStatus.REJECTED
                },
            ],
            query: {},
        }
    },
    methods: {
        clearFromDate() {
            if(this.query.from_date) {
                this.query.from_date = null
            }
        },
        clearToDate() {
            if(this.query.to_date) {
                this.query.to_date = null
            }
        },
    },
    mounted() {
    }
    
}
</script>

<style>

</style>